"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTaskWorker = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const uuid = require("uuid");
const atlas_engine_sdk_2 = require("@atlas-engine/atlas_engine_sdk");
const ExternalTaskApiHttpClient_1 = require("./Clients/ExternalTaskApiHttpClient");
const logger = new atlas_engine_sdk_1.Logger('external_task_worker');
const dummyIdentity = {
    token: 'ZHVtbXlfdG9rZW4=',
    userId: 'dummy_token',
};
class ExternalTaskWorker {
    constructor(atlasEngineUrl, topic, processingFunction, config) {
        var _a, _b, _c, _d, _e;
        this._pollingActive = false;
        this._workerId = (_a = config === null || config === void 0 ? void 0 : config.workerId) !== null && _a !== void 0 ? _a : uuid.v4();
        this.topic = topic;
        this.processingFunction = processingFunction;
        this.identity = (_b = config === null || config === void 0 ? void 0 : config.identity) !== null && _b !== void 0 ? _b : dummyIdentity;
        this.maxTasks = (_c = config === null || config === void 0 ? void 0 : config.maxTasks) !== null && _c !== void 0 ? _c : 10;
        this.longpollingTimeout = (_d = config === null || config === void 0 ? void 0 : config.longpollingTimeout) !== null && _d !== void 0 ? _d : 10000;
        this.lockDuration = (_e = config === null || config === void 0 ? void 0 : config.lockDuration) !== null && _e !== void 0 ? _e : 30000;
        this.payloadFilter = config === null || config === void 0 ? void 0 : config.payloadFilter;
        this.externalTaskClient = new ExternalTaskApiHttpClient_1.ExternalTaskApiClient(atlasEngineUrl, this.identity);
    }
    get identity() {
        return this._identity;
    }
    set identity(value) {
        this._identity = value;
    }
    get workerId() {
        return this._workerId;
    }
    get pollingIsActive() {
        return this._pollingActive;
    }
    start() {
        this._pollingActive = true;
        this.processExternalTasks();
    }
    stop() {
        this._pollingActive = false;
    }
    dispose() {
        this.externalTaskClient.dispose();
    }
    async processExternalTasks() {
        let errorCount = 0;
        const maximumErrorTimeout = 30 * 1000;
        while (this.pollingIsActive) {
            let externalTasks;
            try {
                externalTasks = await this.fetchAndLockExternalTasks();
                errorCount = 0;
            }
            catch (error) {
                logger.error('Failed to fetch and lock External Tasks.', { err: error });
                errorCount++;
                const timeoutOffset = ((Math.floor(Math.random() * 10) + 1) * 30);
                const calculatedTimeout = (2 ** errorCount) * 1000 + timeoutOffset;
                const timeoutToUse = Math.min(calculatedTimeout, maximumErrorTimeout);
                await this.sleep(timeoutToUse);
                externalTasks = [];
            }
            const executeTaskPromises = [];
            for (const externalTask of externalTasks) {
                executeTaskPromises.push(this.executeExternalTask(externalTask));
            }
            await Promise.all(executeTaskPromises);
        }
    }
    async fetchAndLockExternalTasks() {
        return this.externalTaskClient.fetchAndLockExternalTasks(this.workerId, this.topic, this.maxTasks, this.longpollingTimeout, this.lockDuration, this.payloadFilter, this.identity);
    }
    async executeExternalTask(externalTask) {
        let interval;
        try {
            const lockExtensionBuffer = 5000;
            interval =
                setInterval(async () => this.extendLocks(externalTask), this.lockDuration - lockExtensionBuffer);
            const result = await this.processingFunction(externalTask.payload, externalTask);
            clearInterval(interval);
            await this.processResult(result, externalTask.id);
        }
        catch (error) {
            await this.handleExternalTaskExecutionError(error, externalTask === null || externalTask === void 0 ? void 0 : externalTask.id);
            if (interval) {
                clearInterval(interval);
            }
        }
    }
    async extendLocks(externalTask) {
        try {
            await this.externalTaskClient.extendLock(this.workerId, externalTask.id, this.lockDuration, this.identity);
        }
        catch (error) {
            // This can happen, if the lock-extension was performed after the task was already finished.
            // Since this isn't really an error, a warning suffices here.
            logger.warn(`An error occured while trying to extend the lock for ExternalTask ${externalTask.id}`, { err: error });
        }
    }
    async processResult(result, externalTaskId) {
        if (result instanceof atlas_engine_sdk_2.DataModels.ExternalTasks.ExternalTaskBpmnError ||
            result instanceof atlas_engine_sdk_2.DataModels.ExternalTasks.ExternalTaskServiceError ||
            result instanceof Error) {
            return this.handleExternalTaskExecutionError(result, externalTaskId);
        }
        return this.externalTaskClient.finishExternalTask(this.workerId, externalTaskId, result, this.identity);
    }
    async handleExternalTaskExecutionError(error, externalTaskId) {
        logger.error(`Error raised for task '${externalTaskId}' with topic '${this.topic}': `, error);
        if (error instanceof atlas_engine_sdk_2.DataModels.ExternalTasks.ExternalTaskBpmnError) {
            return this.externalTaskClient.handleBpmnError(this.workerId, externalTaskId, error, this.identity);
        }
        if (error instanceof atlas_engine_sdk_2.DataModels.ExternalTasks.ExternalTaskServiceError) {
            return this.externalTaskClient.handleServiceError(this.workerId, externalTaskId, error, this.identity);
        }
        const serviceError = new atlas_engine_sdk_2.DataModels.ExternalTasks.ExternalTaskServiceError('ServiceError', error.message, error.stack);
        return this.externalTaskClient.handleServiceError(this.workerId, externalTaskId, serviceError, this.identity);
    }
    async sleep(milliseconds) {
        return new Promise((resolve) => {
            setTimeout(() => { resolve(); }, milliseconds);
        });
    }
}
exports.ExternalTaskWorker = ExternalTaskWorker;
//# sourceMappingURL=ExternalTaskWorker.js.map